import { CreateEmailCaptureRequest, GetEmailCaptureResponse } from '../../types';
import { GoogleTagEvent, buildQueryString, get, logWithAmplitude, logWithGoogleTagAndTopicOrganization, post, throwHttpError } from './api';

import { TELEMETRY_ENDPOINT } from '../constants';

export async function addEmailCapture(amplitude_callsite: string, topic_id: string, email_capture: CreateEmailCaptureRequest) {
    const response = await fetch(`${TELEMETRY_ENDPOINT}/api/topics/${topic_id}/email_captures`, post(email_capture));

    if (!response.ok) {
        console.error('Failed to add email capture:', response);
        await throwHttpError('An error occurred while adding the email capture', response);
    }

    logWithAmplitude(amplitude_callsite, 'Add Email Capture', {
        topic_id,
    });
    logWithGoogleTagAndTopicOrganization(amplitude_callsite, GoogleTagEvent.POINT_LEAD_COLLECTED, {
        lead_email: email_capture.email
    });
    return await Promise.resolve();
}

export async function getEmailCapturesForTopic(
    amplitude_callsite: string,
    topic_id: string,
    topic_key?: string
) {
    const queryString = buildQueryString({ topic_key });
    const response = await fetch(`/api/topics/${topic_id}/email_captures${queryString}`, get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the email captures.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Email Captures', { topic_id });
    return await (response.json() as Promise<GetEmailCaptureResponse[]>);
}

export async function getEmailCapturesForTopics(
    amplitude_callsite: string,
    topic_array: string[]
) {
    const chunkSize = 50;
    const results: GetEmailCaptureResponse[] = [];

    for (let i = 0; i < topic_array.length; i += chunkSize) {
        const chunk = topic_array.slice(i, i + chunkSize);
        const topic_ids_string = chunk.join(',');
        const url = `/api/email_captures?topic_array=${topic_ids_string}`;

        const response = await fetch(url, get());

        if (!response.ok) {
            await throwHttpError('An error occurred while getting the email captures.', response);
        }

        const chunkResults = await (response.json() as Promise<GetEmailCaptureResponse[]>);
        results.push(...chunkResults);
    }

    logWithAmplitude(amplitude_callsite, 'Get Email Captures');

    return results;
}